module.exports = __webpack_public_path__ + "img/img04.a63cef5f.svg";